// src/components/Home.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../styles/styles.css';
import slugs from '../data/collectionSlugs';
import CollectionsTable from './CollectionsTable';

const Home = ({ account }) => {
  return (
    <div className="container">
      <Helmet>
        <title>Mint Debut — Genesis NFT Collections</title>
        <meta name="description" content="Track genesis NFT collections from the world's top brands, musicians, athletes, and artists. Real-time floor prices, volume, and market cap." />
      </Helmet>
      <div className="page-content">
        <CollectionsTable slugs={slugs} account={account} />
      </div>
    </div>
  );
};

export default Home;
